enum SprintLengthAction {
  UPDATE_SPRINT_LENGTH = 'sprint/updateSprintLength'
}
export default SprintLengthAction;
